import { type AccountAddInput, type AccountAddSuccess, toResponseError } from '@terros/common'
import { useWidgetCache } from '../widget'
import { useTantalimMutation } from '../mutation'
import { useLocationCache } from '../location'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useAccountCache } from './cache'

export function useAddAccount(): AddHookResponse<AccountAddInput['account'], AccountAddSuccess> {
  const locationCache = useLocationCache()
  const accountCache = useAccountCache()
  const widgetCache = useWidgetCache()
  const mutation = useTantalimMutation<AccountAddInput, AccountAddSuccess>({
    url: '/account/add',
  })

  async function add(account: AccountAddInput['account']): Promise<AccountAddSuccess> {
    try {
      const res = await mutation.mutateAsync({ account })
      if (account.locationId) locationCache.clearItem(account.locationId)
      accountCache.clearList()
      widgetCache.clearWidgets()
      widgetCache.clearList()
      return res
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
